import { Component, OnInit } from '@angular/core';
import { ScriptsModule } from '../../modules/scripts.module';
import { Router } from '@angular/router';

declare var jquery:any;
declare var $ :any;
var scripts = new ScriptsModule;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private router:Router) {
    $('#divCargador').show();
    // Home
    // if(router.isActive('home',true)){
    //   console.log('URL: ',router.url);
    //   if(document.readyState === "complete") {
    //     $('#divCargador').hide();
    //     //Already loaded!
    //     $(".topHome").css('height',$('#myCarousel').height());
    //     $(".home-cotizador").css('height',$('.topHome').height());
    //     console.log('El documento ya esta cargado... configurando cotizador');
    //     $('#home-cotizador').addClass('home-cotizador');
    //   }
    //   else {
    //     console.log('Cargando ventana...');
    //     $(window).load(function(){
    //       console.log('obteniendo datos');
    //       $(".topHome").css('height',$('#myCarousel').height());
    //       $(".home-cotizador").css('height',$('.topHome').height());
    //       $('#home-cotizador').addClass('home-cotizador');
    //     });
    //   }
    // }
  }
  ngOnInit() {
    
  }

  facebook(){
    window.open(  'https://www.facebook.com/segurosmedicosinternacionales', '_blank');
  }
  ngAfterViewChecked(){
    if(document.readyState == "complete")
    {
      $('#divCargador').hide();
    }else{
      $(window).load(function(){
        scripts.loadScript('assets/js/scripts/home.js','body');
        $('#divCargador').hide();
      });
    }

  }
  ngOnDestroy(){
    if(typeof $('#home-cotizador') != 'undefined'){
      $('#home-cotizador').removeClass('home-cotizador');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts